import axios from 'axios';

export const fetchXsrfTokenHeaders = async () => {
    const xsrftoken = await axios
        .get(`${process.env.ECONOMIC_PATH}/internal-api/application/anti-forgery`)
        .then(response => response.data);

    return {
        headers: {
            'economic-xsrf': xsrftoken,
        },
    };
};
